import * as moment from 'moment';
import { DashSearchDateType, DashIntakeStatus, IDashListSummary, IDashSearch } from '@nkr/models/dash';
import { OrganType } from '@nkr/enums/organ-type';
import { useAppHookContext, UseSearchReturn } from '@nkr/utils/rest-api';
import { FormControl, Button, Row, Col, FormGroup, ControlLabel, ToggleButtonGroup, ToggleButton, Well } from 'react-bootstrap';

interface IProps {
    search: UseSearchReturn<IDashSearch, IDashListSummary>
}

export const SearchIntendedRecipientFilter = (props: IProps) => {
    const search = props.search;
    const data = props.search.params;

    const { app: { site } } = useAppHookContext();

    return (
        <Well style={{ marginBottom: 5, padding: 10, backgroundColor: '#f5f5f5' }}>
            <form onSubmit={search.handleSearch}>
                <h4>Intended Recipient Details</h4>
                {search.params.micrositeRecipientId > 0 &&
                    <>
                        <h5>
                            Microsite Recipient Search: {search.params.micrositeRecipientId}
                            <Button bsStyle='default' bsSize='small' style={{ marginLeft: 10 }} onClick={() => search.setField('micrositeRecipientId', null)}>Clear</Button>
                        </h5>
                    </>
                }

                {search.params.micrositeRecipientId == null &&
                    <Row>
                        <Col xs={6} sm={4} md={3}>
                            <FormGroup bsSize='sm'>
                                <ControlLabel>First Name:&nbsp;</ControlLabel>
                                <FormControl
                                    name='intendedFirstName'
                                    type="text"
                                    value={data.intendedFirstName}
                                    onChange={props.search.handleStringChange}
                                />
                            </FormGroup>
                        </Col>
                        <Col xs={6} sm={4} md={3}>
                            <FormGroup bsSize='sm'>
                                <ControlLabel>Last Name:&nbsp;</ControlLabel>
                                <FormControl
                                    name='intendedLastName'
                                    type="text"
                                    value={data.intendedLastName}
                                    onChange={props.search.handleStringChange}
                                />
                            </FormGroup>
                        </Col>
                        <Col xs={6} sm={4} md={3}>
                            <FormGroup bsSize='sm'>
                                <ControlLabel>DOB:&nbsp;</ControlLabel>
                                <FormControl
                                    name='intendedDob'
                                    type="date"
                                    value={data.intendedDob}
                                    onChange={props.search.getDateHandler('YYYY-MM-DD')}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                }
                <Row>
                    <Col xs={12} className="form-inline">
                        <div className="alert alert-info alert-sm">
                            <FormGroup bsSize='sm'>
                                <ControlLabel>Search by Date:</ControlLabel>
                                <ToggleButtonGroup type='radio' name='dateSearchType'>
                                    <ToggleButton name='dateSearchType' value='' className={data.dateSearchType == null ? 'btn-primary btn-sm' : 'btn-default btn-sm'} onClick={search.handleIntChange}>None</ToggleButton>
                                    <ToggleButton name='dateSearchType' value={DashSearchDateType.RegistrationDate} className={data.dateSearchType == DashSearchDateType.RegistrationDate ? 'btn-primary btn-sm' : 'btn-default btn-sm'} onClick={search.handleIntChange}>Registered</ToggleButton>
                                    <ToggleButton name='dateSearchType' value={DashSearchDateType.IntakeCompleteDate} className={data.dateSearchType == DashSearchDateType.IntakeCompleteDate ? 'btn-primary btn-sm' : 'btn-default btn-sm'} onClick={search.handleIntChange}>Referred</ToggleButton>
                                    <ToggleButton name='dateSearchType' value={DashSearchDateType.DonationDate} className={data.dateSearchType == DashSearchDateType.DonationDate ? 'btn-primary btn-sm' : 'btn-default btn-sm'} onClick={search.handleIntChange}>Donated</ToggleButton>
                                </ToggleButtonGroup>
                            </FormGroup>
                            {data.dateSearchType != null && <>
                                <FormGroup bsSize='sm'>
                                    <ControlLabel>&nbsp;Between:&nbsp;</ControlLabel>
                                    <input name='filterStartDate' type="date" style={{ width: 150 }} value={moment(data.filterStartDate).format('YYYY-MM-DD')} onChange={search.getDateHandler('YYYY-MM-DD')} className='form-control form-control-sm' />
                                </FormGroup>
                                <FormGroup bsSize='sm'>
                                    <ControlLabel>&nbsp;and:&nbsp;</ControlLabel>
                                    <input name='filterEndDate' type="date" style={{ width: 150 }} value={moment(data.filterEndDate).format('YYYY-MM-DD')} onChange={search.getDateHandler('YYYY-MM-DD')} className='form-control form-control-sm' />
                                </FormGroup>
                            </>
                            }
                        </div>
                    </Col>
                </Row>
                <Row>
                    {site.organType == OrganType.Kidney && (
                        <Col xs={12} sm={6} lg={3}>
                            <FormGroup bsSize='sm'>
                                <ControlLabel>Organ:&nbsp;</ControlLabel>
                                <div>
                                    <ToggleButtonGroup type='radio' name='organType' className="btn-group-justified">
                                        <ToggleButton value='' className={data.organType == null ? 'btn-primary btn-sm' : 'btn-default btn-sm'} onClick={search.handleIntChange}>Both</ToggleButton>
                                        <ToggleButton value={OrganType.Kidney} className={data.organType == OrganType.Kidney ? 'btn-primary btn-sm' : 'btn-default btn-sm'} onClick={search.handleIntChange}>Kidney</ToggleButton>
                                        <ToggleButton value={OrganType.Liver} className={data.organType == OrganType.Liver ? 'btn-primary btn-sm' : 'btn-default btn-sm'} onClick={search.handleIntChange}>Liver</ToggleButton>
                                    </ToggleButtonGroup>
                                </div>
                            </FormGroup>
                        </Col>
                    )}
                    <Col xs={12} sm={6} lg={site.organType == OrganType.Kidney ? 3 : 4}>
                        <FormGroup bsSize='sm'>
                            <ControlLabel>Location:&nbsp;</ControlLabel>
                            <div>
                                <ToggleButtonGroup type='radio' name='isRemote' className="btn-group-justified">
                                    <ToggleButton value='' className={search.equals(data.isRemote, null) ? 'btn-primary btn-sm' : 'btn-default btn-sm'} onClick={search.handleBoolChange}>All</ToggleButton>
                                    <ToggleButton value="false" className={search.equals(data.isRemote, false) ? 'btn-primary btn-sm' : 'btn-default btn-sm'} onClick={search.handleBoolChange}>Local Only</ToggleButton>
                                    <ToggleButton value="true" className={search.equals(data.isRemote, true) ? 'btn-primary btn-sm' : 'btn-default btn-sm'} onClick={search.handleBoolChange}>Remote Only</ToggleButton>
                                </ToggleButtonGroup>
                            </div>
                        </FormGroup>
                    </Col>
                    <Col xs={12} sm={6} lg={site.organType == OrganType.Kidney ? 3 : 4}>
                        <FormGroup bsSize='sm'>
                            <ControlLabel>Include Candidates in Statuses:&nbsp;</ControlLabel>
                            <div>
                                <ToggleButtonGroup
                                    type='checkbox'
                                    name='intakeStatuses'
                                    className="btn-group-justified"
                                    value={(data.intakeStatuses as any[] | undefined)?.map(v => Number(v)) || []}
                                    onChange={search.getIntToggleGroupHandler("intakeStatuses")}
                                >
                                    <ToggleButton value={DashIntakeStatus.Incomplete} className={(data.intakeStatuses?.some(x => String(x) === String(DashIntakeStatus.Incomplete)) ? 'btn-primary' : 'btn-default') + ' btn-sm'}>Incomplete</ToggleButton>
                                    <ToggleButton value={DashIntakeStatus.Referred} className={(data.intakeStatuses?.some(x => String(x) === String(DashIntakeStatus.Referred)) ? 'btn-primary' : 'btn-default') + ' btn-sm'}>Referred</ToggleButton>
                                    <ToggleButton value={DashIntakeStatus.Donated} className={(data.intakeStatuses?.some(x => String(x) === String(DashIntakeStatus.Donated)) ? 'btn-primary' : 'btn-default') + ' btn-sm'}>Donated</ToggleButton>
                                    <ToggleButton value={DashIntakeStatus.RuledOut} className={(data.intakeStatuses?.some(x => String(x) === String(DashIntakeStatus.RuledOut)) ? 'btn-primary' : 'btn-default') + ' btn-sm'}>Ruled Out</ToggleButton>
                                </ToggleButtonGroup>
                            </div>
                        </FormGroup>
                    </Col>
                    <Col xs={12} sm={2} lg={site.organType == OrganType.Kidney ? 3 : 4} className='pull-right'>
                        <FormGroup bsSize='sm'>
                            <ControlLabel>&nbsp;</ControlLabel>
                            <Button type='submit' className='btn-block' bsStyle="primary">Search</Button>
                        </FormGroup>
                    </Col>
                </Row>
            </form>
        </Well>
    );
}